import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticatorService } from './authenticator.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { EvaluacionDocente } from '../Interfaces/evaluacion-docente.interface';
import { EvaluacionDocentePregunta } from '../Interfaces/evaluacion-docente-preguntas.interface';

@Injectable({
    providedIn: 'root',
})
export class EvaluacionDocenteService {
    baseUrl: string = environment.baseUrl;

    constructor(private auth: AuthenticatorService, private http: HttpClient) {}

    findEval(
        no_de_control: string,
        periodo: string
    ): Observable<EvaluacionDocente[]> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/evaluacion-docentes/${no_de_control}/${periodo}`;
        return this.http.get<EvaluacionDocente[]>(url_api, { headers });
    }

    insertUpdateEval(
        no_de_control: string,
        periodo: string,
        materia: string,
        grupo: string,
        evaluacion_docente: Partial<EvaluacionDocente>
    ): Observable<EvaluacionDocente> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/evaluacion-docentes/${no_de_control}/${periodo}/${materia}/${grupo}`;
        return this.http.patch<EvaluacionDocente>(url_api, evaluacion_docente, {
            headers,
        });
    }

    getPregruntas(): Observable<EvaluacionDocentePregunta[]> {
        const headers = this.auth.headers;
        const url_api = `${this.baseUrl}/evaluacion-docente-preguntas `;
        return this.http.get<EvaluacionDocentePregunta[]>(url_api, {
            headers,
        });
    }
}
